export default "__VITE_ASSET__CDFAd0kJ__"